export default __webpack_public_path__ + "static/media/hello.a0eb56b0.png";